(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}(function () { 'use strict';

    class AlgoliaUtils {
        constructor() {
            this.class = {
                searchOverlayInput: '.js-gs-overlay-searchinput',
                searchResultsInput: '.js-gs-resultpage-searchinput',
                searchResultsFilter: '.js-gs-searchform--filter-checkbox',
                searchResultsFacets: '.js-gs-filters-list',
                searchResultTiles: '.gs-searchresult-tile',
                searchResultsList: '.js-searchresults-list',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', AlgoliaUtils.init.bind(this), false);
            } else {
                AlgoliaUtils.init();
            }
        }

        static init() {
            // const searchResultsInput = document.querySelector(this.class.searchResultsInput);
        }

        async getCurrentSearchParams() {
            const searchOverlayInput = document.querySelector(this.class.searchOverlayInput);
            const searchResultsFilter = document.querySelector(this.class.searchResultsFilter);
            const searchResultsFacets = document.querySelector(this.class.searchResultsFacets);
            const checkedFacet = searchResultsFacets ? searchResultsFacets.querySelector('input[type="checkbox"]:checked') : null;
            const facets = [];
            let q = searchOverlayInput ? searchOverlayInput.value.toLowerCase() : '';

            // overlay input is empty on a fresh page load, fall back to the URL so a direct/reloaded search page keeps its query
            if (!q && window.location.search) {
                q = new URLSearchParams(window.location.search).get('q') || '';
            }

            // Check for the current page only filter and add it to the facets array if checked
            if (searchResultsFilter && searchResultsFilter.checked) {
                facets.push('package:' + searchResultsFilter.dataset.currentPageOnly);
            }

            // Check for the checked facet and add it to the facets array if it's not "all"
            if (checkedFacet && checkedFacet.value !== 'all') {
                facets.push('type:' + checkedFacet.value);
            }

            return { q, facets };
        }

        // the checkboxes are the single source of truth for getCurrentSearchParams(), so a
        // facetFilters value from the URL has to be applied to them before the first search
        applyFacetsFromLocation() {
            const facetFilters = new URLSearchParams(window.location.search).get('facetFilters');

            if (!facetFilters) {
                return;
            }

            let facets = [];

            try {
                facets = JSON.parse(facetFilters);
            } catch (error) {
                return;
            }

            if (!Array.isArray(facets)) {
                return;
            }

            const searchResultsFilter = document.querySelector(this.class.searchResultsFilter);
            const searchResultsFacets = document.querySelector(this.class.searchResultsFacets);
            const facetCheckboxes = searchResultsFacets ? Array.from(searchResultsFacets.querySelectorAll('input[type="checkbox"]')) : [];

            facetCheckboxes.forEach((_, index) => {
                facetCheckboxes[index].checked = false;
            });

            facets.forEach((facet) => {
                const separatorIndex = String(facet).indexOf(':');

                if (separatorIndex < 0) {
                    return;
                }

                const attribute = String(facet).slice(0, separatorIndex);
                const value = String(facet).slice(separatorIndex + 1);

                if (attribute === 'package' && searchResultsFilter && searchResultsFilter.dataset.currentPageOnly === value) {
                    searchResultsFilter.checked = true;
                }

                if (attribute === 'type') {
                    const checkbox = facetCheckboxes.find((facetCheckbox) => facetCheckbox.value === value);

                    if (checkbox) {
                        checkbox.checked = true;
                    }
                }
            });
        }

        // mirrors SearchController::resolveQuery() so queries without any letter/digit
        // (e.g. only backslashes/symbols) never trigger a request that would return all results;
        // also requires at least 3 characters (trimmed) to avoid overly broad searches
        hasRealQuery(value) {
            return String(value).trim().length >= 3 && /\p{L}|\p{N}/u.test(value);
        }

        // falls back to the unfiltered "all" facet, e.g. when the currently selected
        // type facet has no results for a query that changed after the facet was picked
        resetFacetToAll() {
            const searchResultsFacets = document.querySelector(this.class.searchResultsFacets);
            const facetCheckboxes = searchResultsFacets ? Array.from(searchResultsFacets.querySelectorAll('input[type="checkbox"]')) : [];

            facetCheckboxes.forEach((_, index) => {
                facetCheckboxes[index].checked = facetCheckboxes[index].value === 'all';
            });
        }

        getAjaxEndpoint() {
            const overlay = document.querySelector('[data-algolia-endpoint]');

            if (overlay) {
                return window.location.origin + overlay.dataset.algoliaEndpoint;
            }

            return window.location.origin + window.location.pathname.replace(/\/+$/, '');
        }

        // the overlay can be opened from any page, but q/facetFilters/page are only meaningful
        // (and must only be written) on the actual search results page
        isOnSearchResultsPage() {
            return document.querySelector('.js-gs-searchresults') !== null;
        }

        async updateLocationParams(q, facets) {
            if (!this.isOnSearchResultsPage()) {
                return;
            }

            const searchParams = new URLSearchParams(window.location.search);

            searchParams.set('q', q);
            if (facets) {
                searchParams.set('facetFilters', JSON.stringify(facets));
            }
            history.replaceState(null, '', `${window.location.pathname}?${searchParams.toString()}`);
        }

        updatePageParam(page) {
            if (!this.isOnSearchResultsPage()) {
                return;
            }

            const searchParams = new URLSearchParams(window.location.search);

            searchParams.set('page', page);
            history.replaceState(null, '', `${window.location.pathname}?${searchParams.toString()}`);
        }

        async updateSearchInputValues() {
            if (location.search) {
                const searchOverlayInput = document.querySelector(this.class.searchOverlayInput);
                const searchResultsInput = document.querySelector(this.class.searchResultsInput);
                const params = new URLSearchParams(location.search);
                const q = params.get('q');

                if (searchOverlayInput) {
                    searchOverlayInput.value = q;
                }

                if (searchResultsInput) {
                    searchResultsInput.value = q;
                }
            }
        }

        async checkForCurrentPageOnlyFilter() {
            const currentPageOnlyCheckboxes = document.querySelectorAll('input[type="checkbox"][data-current-page-only]');
            const hasCheckedCurrentPageOnlyFilter = Array.from(currentPageOnlyCheckboxes).some((checkbox) => checkbox.checked);

            return hasCheckedCurrentPageOnlyFilter;
        }

        hideSearchResultTiles() {
            // freeze the wrapper height first, otherwise hiding the tiles collapses the
            // page and the scroll position jumps down before the new results reveal it back up
            const wrapper = document.querySelector(this.class.searchResultsList);
            if (wrapper) {
                wrapper.style.minHeight = `${wrapper.offsetHeight}px`;
            }

            document.querySelectorAll(this.class.searchResultTiles).forEach((tile) => {
                tile.setAttribute('hidden', 'hidden');
            });
        }

        revealSearchResultTiles() {
            document.querySelectorAll(this.class.searchResultTiles).forEach((tile, index) => {
                tile.removeAttribute('hidden');
                tile.style.setProperty('--gs-searchresult-tile-delay', `${index * 35}ms`);
                tile.classList.add('gs-searchresult-tile--revealing');

                tile.addEventListener('animationend', () => {
                    tile.classList.remove('gs-searchresult-tile--revealing');
                    tile.style.removeProperty('--gs-searchresult-tile-delay');
                }, { once: true });
            });

            const wrapper = document.querySelector(this.class.searchResultsList);
            if (wrapper) {
                wrapper.style.removeProperty('min-height');
            }
        }
    }

    var AlgoliaUtils$1 = new AlgoliaUtils();

    class AlgoliaRenderer {
        constructor() {
            this.class = {
                btnOpenOverlay: '.js-gs-btn-open-overlay',
                btnCloseOverlay: '.js-gs-overlay-close',
                overlay: '.js-gs-overlay',
                searchForm: '.js-gs-overlay-searchform',
                searchInput: '.js-gs-overlay-searchinput',
                suggestions: '.js-gs-suggestions-no-input',
                suggestionsWithInput: '.js-gs-suggestions-input',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', AlgoliaRenderer.init.bind(this), false);
            } else {
                AlgoliaRenderer.init();
            }

            this.listenForBasketFeedback();
        }

        static init() {
        }

        // shopware6_connector's basket.js click-adds products via its own XHR with no event/callback
        // hook, so feedback here is inferred purely from the DOM side effects it already produces
        // (cart count text change = success, .js-basket-error becoming visible = error).
        listenForBasketFeedback() {
            const clearPendingState = () => {
                clearTimeout(this.pendingAddProductTimeout);
                this.pendingAddProductButton = null;
            };

            const resolvePendingButton = (resultClass) => {
                const button = this.pendingAddProductButton;
                if (!button) {
                    return;
                }
                clearPendingState();
                button.classList.remove('is-adding');
                button.removeAttribute('aria-busy');
                if (resultClass) {
                    button.classList.add(resultClass);
                    setTimeout(() => button.classList.remove(resultClass), 3000);
                }
                if (resultClass === 'is-added') {
                    const template = document.querySelector('#action-buy-online');
                    if (template && template.dataset.basketUrl) {
                        window.open(template.dataset.basketUrl, '_blank', 'noopener');
                    }
                }
            };

            // capture phase: runs before basket.js's own (bubbling) click listener starts its XHR
            document.addEventListener('click', (event) => {
                const button = event.target.closest && event.target.closest('.js-add-product');
                if (!button) {
                    return;
                }

                clearPendingState();
                this.pendingAddProductButton = button;
                button.classList.remove('is-added', 'is-add-error');
                button.classList.add('is-adding');
                button.setAttribute('aria-busy', 'true');

                // safety net in case basket.js never touches the DOM (e.g. request fails silently)
                this.pendingAddProductTimeout = setTimeout(() => resolvePendingButton(null), 8000);
            }, true);

            const observer = new MutationObserver((mutations) => {
                if (!this.pendingAddProductButton) {
                    return;
                }

                mutations.some((mutation) => {
                    const target = mutation.target;
                    if (!target.classList) {
                        return false;
                    }
                    if (target.classList.contains('js-basket-error') && !target.classList.contains('d-none')) {
                        resolvePendingButton('is-add-error');
                        return true;
                    }
                    if (target.classList.contains('js-cart-count')) {
                        resolvePendingButton('is-added');
                        return true;
                    }
                    return false;
                });
            });

            observer.observe(document.body, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: ['class'],
            });
        }

        // const autocomplete_container = document.querySelector('#testtarget');
        toggleSuggestions(state) {
            const suggestionsContainerInitial = document.querySelector(this.class.suggestions);
            const suggestionsContainer = document.querySelector(this.class.suggestionsWithInput);

            if (state === 'initial') {
                suggestionsContainerInitial.classList.add('visible');
                suggestionsContainer.classList.remove('visible');

                return;
            }

            suggestionsContainerInitial.classList.remove('visible');
            suggestionsContainer.classList.add('visible');
        }

        // eslint-disable-next-line class-methods-use-this
        disableActionButton(button) {
            if (!button) {
                return;
            }

            // Anchors cannot be disabled natively, so the link target is removed instead.
            button.removeAttribute('href');
            button.classList.add('is-disabled');
            button.setAttribute('aria-disabled', 'true');
            button.setAttribute('tabindex', '-1');
        }

        // eslint-disable-next-line class-methods-use-this
        isSafeUrl(url) {
            try {
                return ['http:', 'https:'].includes(new URL(url, window.location.origin).protocol);
            } catch (error) {
                return false;
            }
        }

        // eslint-disable-next-line class-methods-use-this
        clearAutosuggestResults() {
            const wrapper = document.querySelector('.js-gs-suggestions--best-queries');
            const list = wrapper.querySelector('ul');
            list.textContent = '';
            list.classList.remove('gs-suggestions-text--noresults');
        }

        async renderAutosuggestResults(searchString, hits) {
            const wrapper = document.querySelector('.js-gs-suggestions--best-queries');
            const list = wrapper.querySelector('ul');
            list.textContent = '';
            list.classList.toggle('gs-suggestions-text--noresults', hits.length === 0);

            if (hits.length === 0) {
                const li = document.createElement('li');
                const strong = document.createElement('b');
                strong.textContent = searchString;
                li.append(`${wrapper.dataset.labelNoresults} `, strong);
                list.appendChild(li);
                return;
            }

            hits.forEach((hit) => {
                /* eslint no-underscore-dangle: ["error", { "allow": ["_highlightResult"] }] */
                const li = document.createElement('li');
                // Algolia escapes the underlying text itself and only injects its own highlight tags around matches.
                const highlight = hit._highlightResult.query.value;

                if (hit.url === undefined) {
                    const button = document.createElement('button');
                    button.dataset.query = hit.query;
                    button.innerHTML = highlight;
                    li.appendChild(button);
                } else {
                    const anchor = document.createElement('a');
                    anchor.href = this.isSafeUrl(hit.url) ? hit.url : '#';
                    anchor.target = '_blank';
                    anchor.rel = 'noopener noreferrer';
                    anchor.innerHTML = highlight;
                    li.appendChild(anchor);
                }

                list.appendChild(li);
            });
        }

        async renderTopResults(searchString, hits) {
            const wrapper = document.querySelector('.js-gs-suggestions--best-results ul');
            if (!wrapper) {
                return;
            }

            const resultTileTemplate = document.querySelector('#top-result-tile');
            const resultIconProductTemplate = document.querySelector('#top-result-icon-product');
            const resultIconPageTemplate = document.querySelector('#top-result-icon-page');
            const resultIconDocumentTemplate = document.querySelector('#top-result-icon-document');
            /*
            const btnBuyOnlineTemplate = document.querySelector('#action-buy-online');
            const btnInfoTemplate = document.querySelector('#action-info');
            const btnDownloadTemplate = document.querySelector('#action-download');
            */

            if (!resultTileTemplate) {
                console.error('renderTopResults: #result-tile template not found in DOM');
                return;
            }

            wrapper.querySelectorAll('.gs-suggestion-tile').forEach((tile) => tile.remove());

            hits.forEach((hit) => {
                if (!hit) {
                    return;
                }
                if (hit.nbHits === 0) {
                    return;
                }

                const hitData = hit.hits[0];

                const clone = document.importNode(resultTileTemplate.content, true);
                if (hitData.deeplink) {
                    clone.querySelector('.js-top-result-tile-link').href = hitData.deeplink;
                } else {
                    clone.querySelector('.js-top-result-tile-link').href = hitData.url || '#';
                }
                clone.querySelector('.js-title').textContent = hitData.title || '-';
                const content = hitData.content || '-';
                clone.querySelector('.js-content').textContent = content.length > 75 ? `${content.slice(0, 75)}…` : content;
                // clone.querySelector('.js-top-result-tile-link').href = hitData.url || '#';
                const img = clone.querySelector('.js-result-image');
                img.src = hitData.image || img.dataset.placeholder || '';
                const icon = clone.querySelector('.js-top-result-tile-icon');

                if (hitData.type === 'product') {
                    const iconTemplate = document.importNode(resultIconProductTemplate.content, true);
                    // iconTemplate.querySelector('.js-top-result-tile-icon').href = hitData.deeplink;
                    icon.appendChild(iconTemplate);
                }

                if (hitData.type === 'page') {
                    const iconTemplate = document.importNode(resultIconPageTemplate.content, true);
                    // iconTemplate.querySelector('.js-top-result-tile-icon').href = hitData.deeplink;
                    icon.appendChild(iconTemplate);
                }

                if (hitData.type === 'document') {
                    const iconTemplate = document.importNode(resultIconDocumentTemplate.content, true);
                    // iconTemplate.querySelector('.js-top-result-tile-icon').href = hitData.deeplink;
                    icon.appendChild(iconTemplate);
                }

                wrapper.appendChild(clone);
            });
        }

        async renderResultsCount(response) {
            const resultsCount = document.querySelector('.js-results-count');
            const resultsCountCurrent = document.querySelector('.js-results-count-current');
            const resultsCountTotal = document.querySelector('.js-results-count-total');
            const resultsCountForQueryString = document.querySelector('.js-results-for-querystring');

            const result = response.results[0];
            const nbHits = Number(result.nbHits) || 0;
            const hitsPerPage = Number(result.hitsPerPage) || 0;
            const currentPage = (Number(result.page) || 0) + 1;
            const rangeStart = nbHits === 0 ? 0 : ((currentPage - 1) * hitsPerPage) + 1;
            const rangeEnd = nbHits === 0 ? 0 : Math.min(currentPage * hitsPerPage, nbHits);
            const resultCountString = `Ergebnisse ${rangeStart} - ${rangeEnd} von ${nbHits}`;

            if (resultsCount) {
                resultsCount.setAttribute('aria-label', resultCountString);
            }

            if (resultsCountCurrent) {
                resultsCountCurrent.textContent = `${rangeStart} - ${rangeEnd}`;
            }

            if (resultsCountTotal) {
                resultsCountTotal.textContent = nbHits;
            }

            resultsCountForQueryString.textContent = result.query || '';
        }

        async renderPageCount(response) {
            const pageCount = document.querySelector('.js-total-pages');
            const pageCurrent = document.querySelector('.js-current-page');

            const result = response.results[0];
            const currentPage = (Number(result.page) || 0) + 1;
            const nbPages = Number(result.nbPages) || 0;

            if (currentPage) {
                pageCurrent.textContent = currentPage;
            }

            if (pageCount) {
                pageCount.textContent = nbPages;
            }
        }

        async renderPagination(response) {
            const pagination = document.querySelector('.js-gs-pagination');
            if (!pagination) {
                return;
            }

            const result = response.results[0];
            const currentPage = (Number(result.page) || 0) + 1;
            const nbPages = Number(result.nbPages) || 0;

            if (nbPages > 1) {
                pagination.classList.add('is-visible');
            }

            if (nbPages <= 1) {
                pagination.classList.remove('is-visible');
                return;
            }

            const template = document.querySelector('#pagination-item');
            const nextButton = pagination.querySelector('.js-gs-paging-next');

            if (!template || !nextButton) {
                return;
            }

            pagination.querySelectorAll('.js-gs-paging-page').forEach((button) => button.remove());
            pagination.querySelectorAll('.gs-pagination-ellipsis').forEach((el) => el.remove());

            // Returns page numbers + null sentinels for ellipsis positions
            const buildPages = (cp, total) => {
                if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
                if (cp <= 4) return [1, 2, 3, 4, 5, null, total];
                if (cp >= total - 3) return [1, null, total - 4, total - 3, total - 2, total - 1, total];
                return [1, null, cp - 1, cp, cp + 1, null, total];
            };

            buildPages(currentPage, nbPages).forEach((page) => {
                if (page === null) {
                    const ellipsis = document.createElement('span');
                    ellipsis.classList.add('gs-pagination-ellipsis');
                    ellipsis.textContent = '…';
                    pagination.insertBefore(ellipsis, nextButton);
                    return;
                }
                const clone = document.importNode(template.content, true);
                const anchor = clone.querySelector('.js-gs-paging-page');
                anchor.textContent = page;
                anchor.dataset.page = page - 1;
                if (page === currentPage) {
                    anchor.classList.add('current-page');
                }
                pagination.insertBefore(clone, nextButton);
            });

            const setDisabled = (el, disabled) => {
                el.classList.toggle('is-disabled', disabled);
                el.setAttribute('aria-disabled', disabled);
            };

            setDisabled(pagination.querySelector('.js-gs-paging-first'), currentPage === 1);
            setDisabled(pagination.querySelector('.js-gs-paging-previous'), currentPage === 1);
            setDisabled(pagination.querySelector('.js-gs-paging-next'), currentPage === nbPages);
            setDisabled(pagination.querySelector('.js-gs-paging-last'), currentPage === nbPages);

            pagination.classList.add('is-visible');
        }

        async renderSearchResultsFacets(response) {
            const facetAll = document.querySelectorAll('.js-gs-filters-pill--facetall');
            const facetProducts = document.querySelectorAll('.js-gs-filters-pill--facetproducts');
            const facetPages = document.querySelectorAll('.js-gs-filters-pill--facetpages');
            const facetDocuments = document.querySelectorAll('.js-gs-filters-pill--facetdocuments');

            const hits = response.results[1].facetHits;

            const facetMap = {
                product: facetProducts,
                page: facetPages,
                document: facetDocuments,
            };

            let totalCount = 0;

            Object.values(facetMap).map((elements) => Array.from(elements).map((el) => Object.assign(el, { textContent: 0 })));

            hits.map((hit) => {
                totalCount += hit.count;
                const elements = facetMap[hit.value];
                if (elements) {
                    Array.from(elements).map((el) => Object.assign(el, { textContent: hit.count }));
                }
                return hit;
            });

            Array.from(facetAll).map((el) => Object.assign(el, { textContent: totalCount }));

            const filtersList = document.querySelector('.js-gs-filters-list');
            if (filtersList) {
                const specificFacetCheckboxes = filtersList.querySelectorAll('#facetproducts, #facetpages, #facetdocuments');
                const anySpecificSelected = Array.from(specificFacetCheckboxes).some((checkbox) => checkbox.checked);
                if (!anySpecificSelected) {
                    const facetAllCheckbox = filtersList.querySelector('#facetall');
                    if (facetAllCheckbox) {
                        facetAllCheckbox.checked = true;
                    }
                }
            }
        }

        async renderSearchResults(response) {
            const wrapper = document.querySelector('.js-searchresults-list');
            wrapper.classList.add('searchresults');
            wrapper.querySelectorAll('.gs-searchresult-tile').forEach((tile) => tile.remove());
            const resultTileTemplate = document.querySelector('#result-tile');
            const noResultTileTemplate = document.querySelector('#no-result-tile');

            if (!resultTileTemplate) {
                console.error('renderSearchResults: #result-tile template not found in DOM');
                return;
            }

            const btnBuyOnlineTemplate = document.querySelector('#action-buy-online');
            // const btnBuyLocalTemplate = document.querySelector('#action-buy-local');
            const btnInfoTemplate = document.querySelector('#action-info');
            // const btnTestTemplate = document.querySelector('#action-test');
            const btnDownloadTemplate = document.querySelector('#action-download');
            const hits = response.results[0].hits;
            const count = hits.length;

            if (response.results[0].nbHits === 0) {
                const clone = document.importNode(noResultTileTemplate.content, true);
                // clone.querySelector('.js-content').textContent = 'Keine Treffer';
                wrapper.appendChild(clone);
            }

            for (let index = 0; index < count; index++) {
                const clone = document.importNode(resultTileTemplate.content, true);
                const cloneActions = clone.querySelector('.js-gs-searchresult-actions');
                const img = clone.querySelector('.js-result-image');
                img.src = hits[index].image || img.dataset.placeholder || '';
                clone.querySelector('.js-packagename').textContent = hits[index].package_displayname;
                clone.querySelector('.js-packageurl').textContent = hits[index].url;
                clone.querySelector('.js-results').textContent = hits[index].title;
                clone.querySelector('.js-results').href = hits[index].url;

                if (hits[index].imageIsAiGenerated) {
                    img.classList.add('is-ai-generated');
                }

                if (hits[index].quickfacts[0].pharmacyonly === false) {
                    clone.querySelector('.js-pharmacyonly').remove();
                }

                if (hits[index].quickfacts[0].productid) {
                    clone.querySelector('.js-productid').textContent = '#' + hits[index].quickfacts[0].productid;
                } else {
                    clone.querySelector('.js-productid').remove();
                }

                if (hits[index].pzn && hits[index].quickfacts[0].pharmacyonly === false) {
                    clone.querySelector('.js-productonly').remove();
                }

                if (hits[index].quickfacts[0].category) {
                    clone.querySelector('.js-quickfact-category-label').textContent = hits[index].quickfacts[0].category;
                } else {
                    clone.querySelector('.js-quickfact-category').remove();
                }

                if (hits[index].quickfacts[0].filesize) {
                    clone.querySelector('.js-quickfact-filesize').textContent = hits[index].quickfacts[0].filesize;
                } else {
                    clone.querySelector('.js-quickfact-filesize').remove();
                }

                const content = hits[index].content || '-';
                clone.querySelector('.js-content').textContent = content.length > 250 ? `${content.slice(0, 250)}…` : content;

                // Actions
                if (hits[index].type === 'product') {
                    const actionTemplate = document.importNode(btnBuyOnlineTemplate.content, true);
                    const buyOnlineButton = actionTemplate.querySelector('.js-btn-buy-online');
                    if (hits[index].quickfacts[0].deeplink !== '#') {
                        buyOnlineButton.href = hits[index].quickfacts[0].deeplink;
                    } else if (this.isSafeUrl(hits[index].url) && new URL(hits[index].url, window.location.origin).origin !== window.location.origin) {
                        // The cart lives on the shop site's domain, so hand the product over to its detail page.
                        const handoffUrl = new URL(hits[index].url, window.location.origin);
                        handoffUrl.searchParams.set('addToBasket', 'true');
                        buyOnlineButton.href = handoffUrl.href;
                        actionTemplate.querySelector('.js-btn-buy-online-label').textContent = btnBuyOnlineTemplate.dataset.labelAddToCart;
                    } else {
                        // buyOnlineButton.href = hits[index].url;
                        if (hits[index].availability !== false) {
                            buyOnlineButton.classList.add('js-add-product');
                        }
                        buyOnlineButton.removeAttribute('target');
                        buyOnlineButton.setAttribute('data-pid', btnBuyOnlineTemplate.dataset.pid);
                        buyOnlineButton.setAttribute('data-product', hits[index].quickfacts[0].identifier);
                        buyOnlineButton.setAttribute('data-productid', hits[index].quickfacts[0].productid);
                        actionTemplate.querySelector('.js-btn-buy-online-label').textContent = btnBuyOnlineTemplate.dataset.labelAddToCart;
                    }

                    if (hits[index].availability === false) {
                        this.disableActionButton(buyOnlineButton);
                    }

                    cloneActions.appendChild(actionTemplate);
                }

                if (hits[index].type === 'page') {
                    const actionTemplate = document.importNode(btnInfoTemplate.content, true);
                    actionTemplate.querySelector('.js-btn-info').href = hits[index].url;
                    cloneActions.appendChild(actionTemplate);
                }

                if (hits[index].type === 'document') {
                    const actionTemplate = document.importNode(btnDownloadTemplate.content, true);
                    actionTemplate.querySelector('.js-btn-download').href = hits[index].quickfacts[0].deeplink;
                    cloneActions.appendChild(actionTemplate);
                }

                wrapper.appendChild(clone);
            }

            AlgoliaUtils$1.revealSearchResultTiles();
        }
    }

    var AlgoliaRenderer$1 = new AlgoliaRenderer();

    class LoadingSpinner {
        add(target) { // eslint-disable-line class-methods-use-this
            const loadingSpinner = '<div class="spinner-border-overlay"><div class="spinner-border" role="status">\n'
                + '<span class="visually-hidden">Loading...</span>\n'
                + '</div></div>';
            if (target) {
                document.querySelector(target).insertAdjacentHTML('beforeend', loadingSpinner);
            } else {
                console.log('LoadingSpinner added to default');
                document.body.insertAdjacentHTML('beforeend', loadingSpinner);
            }
        }

        remove() { // eslint-disable-line class-methods-use-this
            document.querySelectorAll('.spinner-border-overlay').forEach((spinner) => spinner.remove());
        }
    }

    /* eslint no-underscore-dangle: ['error', { 'allow': ['_quickResultsDebounceTimer', '_quickResultsAbortController'] }] */

    class AlgoliaAjaxActions {
        constructor() {
            this.loadingSpinner = new LoadingSpinner();
            this.hitsPerPage = 10;

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', AlgoliaAjaxActions.init.bind(this), false);
            } else {
                AlgoliaAjaxActions.init();
            }
        }

        static init() {
        }

        // Combines the autosuggest and per-facet top-results queries into a single debounced
        // request, since both are always needed together for the same keystroke (see caller).
        async performAjaxQuickResults(debounceDelay = 300) {
            const self = this;

            clearTimeout(this._quickResultsDebounceTimer);
            // cancel a still in-flight request so its (possibly slower) response can never overwrite a newer one
            if (this._quickResultsAbortController) {
                this._quickResultsAbortController.abort();
            }

            return new Promise((resolve, reject) => {
                this._quickResultsDebounceTimer = setTimeout(async () => {
                    const abortController = new AbortController();
                    self._quickResultsAbortController = abortController;

                    const params = await AlgoliaUtils$1.getCurrentSearchParams();
                    const { q, facets } = params;

                    const queryParams = new URLSearchParams({
                        type: 1706000001,
                        'tx_msqdxalgolia_searchdetail[action]': 'algoliaQuickResults',
                        'tx_msqdxalgolia_searchdetail[controller]': 'Search',
                        'tx_msqdxalgolia_searchdetail[query]': q,
                        'tx_msqdxalgolia_searchdetail[hitsPerPage]': this.hitsPerPage ? this.hitsPerPage : 10,
                    });

                    // URLSearchParams would flatten the array into a single comma separated value
                    facets.forEach((facet) => queryParams.append('tx_msqdxalgolia_searchdetail[facetFilters][]', facet));

                    const url = AlgoliaUtils$1.getAjaxEndpoint();
                    const separator = url.includes('?') ? '&' : '?';

                    try {
                        self.loadingSpinner.add('.js-gs-suggestions--best-queries');
                        self.loadingSpinner.add('.js-gs-suggestions--best-results');
                        const response = await fetch(`${url}${separator}${queryParams.toString()}`, {
                            method: 'GET',
                            signal: abortController.signal,
                        });

                        if (!response.ok) {
                            throw new Error(`HTTP error: ${response.status}`);
                        }

                        self.loadingSpinner.remove();
                        resolve(response.json());
                    } catch (error) {
                        self.loadingSpinner.remove();
                        if (error.name === 'AbortError') {
                            resolve(undefined);
                            return;
                        }
                        reject(error);
                    }
                }, debounceDelay);
            });
        }

        // perform the request to get the suggestions
        async performBestHits() {
            const self = this;
            const params = await AlgoliaUtils$1.getCurrentSearchParams();
            const { q } = params;

            self.loadingSpinner.add('.js-gs-suggestions--best-queries');
            const response = await this.searchClient.search({
                requests: [
                    { indexName: 'oneforall', query: q, hitsPerPage: 25 },
                ],
            });
            return response;
        }

        // perform the search via the PHP AJAX endpoint (algoliaAction)
        // isRetryAfterFacetReset guards against infinite recursion once the type facet was reset to "all"
        async performAjaxSearch(page, isRetryAfterFacetReset = false) {
            const self = this;
            const params = await AlgoliaUtils$1.getCurrentSearchParams();
            const { q, facets } = params;

            // show loading spinner while request
            if (document.querySelector('.js-searchresults-list')) {
                AlgoliaUtils$1.hideSearchResultTiles();
                self.loadingSpinner.add('.js-searchresults-list');
            }

            // await AlgoliaUtils.checkForCurrentPageOnlyFilter();
            await AlgoliaUtils$1.updateLocationParams(q, facets);
            await AlgoliaUtils$1.updateSearchInputValues();

            const queryParams = new URLSearchParams({
                type: 1706000001,
                'tx_msqdxalgolia_searchdetail[action]': 'algoliaSearch',
                'tx_msqdxalgolia_searchdetail[controller]': 'Search',
                'tx_msqdxalgolia_searchdetail[query]': q,
                'tx_msqdxalgolia_searchdetail[page]': page,
                'tx_msqdxalgolia_searchdetail[hitsPerPage]': this.hitsPerPage ? this.hitsPerPage : 10,
            });

            // URLSearchParams would flatten the array into a single comma separated value
            facets.forEach((facet) => queryParams.append('tx_msqdxalgolia_searchdetail[facetFilters][]', facet));

            const url = AlgoliaUtils$1.getAjaxEndpoint();
            const separator = url.includes('?') ? '&' : '?';
            const response = await fetch(`${url}${separator}${queryParams.toString()}`, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            if (document.querySelector('.js-searchresults-list')) {
                self.loadingSpinner.remove();
            }

            const json = await response.json();

            // a query change can leave a previously selected type facet (product/page/document)
            // without any results - fall back to "all" and redo the search once
            const hasTypeFacet = facets.some((facet) => facet.startsWith('type:'));
            const nbHits = Number(json.results[0].nbHits) || 0;

            if (!isRetryAfterFacetReset && hasTypeFacet && nbHits === 0) {
                AlgoliaUtils$1.resetFacetToAll();
                return this.performAjaxSearch(page, true);
            }

            return json;
        }
    }

    var AlgoliaAjaxActions$1 = new AlgoliaAjaxActions();

    class AlgoliaEventListener {
        constructor() {
            this.class = {
                btnOpenOverlay: '.js-gs-btn-open-overlay',
                btnOpenOverlayMobile: '.js-gs-btn-open-overlay--mobile',
                btnCloseOverlay: '.js-gs-overlay-close',
                btnClearSearchInput: '.js-gs-overlay-clear',
                overlay: '.js-gs-overlay',
                searchForm: '.js-gs-overlay-searchform',
                searchInput: '.js-gs-overlay-searchinput',
                btnSubmitSearch: '.js-gs-overlay-submit',
                suggestions: '.js-gs-suggestions-no-input',
                suggestionsWithInput: '.js-gs-suggestions-input',
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        async init() {
            this.listenForInteraction();
        }

        listenForInteraction() {
            // basic elements
            const overlay = document.querySelector(this.class.overlay);
            const btnOpenOverlay = document.querySelector(this.class.btnOpenOverlay);
            const btnOpenOverlayMobile = document.querySelector(this.class.btnOpenOverlayMobile);
            const btnCloseOverlay = document.querySelector(this.class.btnCloseOverlay);
            const btnClearSearchInput = document.querySelector(this.class.btnClearSearchInput);

            // elements inside the overlay
            const searchForm = document.querySelector(this.class.searchForm);
            const searchInput = document.querySelector(this.class.searchInput);
            const btnSubmitSearch = document.querySelector(this.class.btnSubmitSearch);

            // reflects whether a submit would actually be allowed (see the 'submit' listener below)
            const updateSubmitState = () => {
                const currentPageOnlyChecked = searchForm.querySelector('.js-gs-searchform--filter-checkbox:checked');

                btnSubmitSearch.disabled = !AlgoliaUtils$1.hasRealQuery(searchInput.value) && !currentPageOnlyChecked;
            };

            updateSubmitState();
            searchForm.addEventListener('change', updateSubmitState);

            const staticQueries = document.querySelector('.js-gs-suggestions--static-queries');

            staticQueries.addEventListener('click', async (event) => {
                if (event.target.tagName === 'BUTTON') {
                    const searchString = event.target.dataset.query;

                    document.querySelector(this.class.searchInput).value = searchString;
                    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });

            const topSearches = document.querySelector('.js-gs-suggestions--others-top-searches');
            topSearches.addEventListener('click', async (event) => {
                if (event.target.tagName === 'BUTTON') {
                    const searchString = event.target.dataset.query;

                    document.querySelector(this.class.searchInput).value = searchString;
                    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });

            const bestQueries = document.querySelector('.js-gs-suggestions--best-queries');
            bestQueries.addEventListener('click', async (event) => {
                if (event.target.tagName === 'BUTTON') {
                    const searchString = event.target.dataset.query;

                    document.querySelector(this.class.searchInput).value = searchString;
                    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });

            const bestResults = document.querySelector('.js-gs-suggestions--best-results');
            bestResults.addEventListener('click', async (event) => {
                if (event.target.tagName === 'A') {
                    const searchString = event.target.textContent;

                    document.querySelector(this.class.searchInput).value = searchString;
                    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });

            btnClearSearchInput.addEventListener('click', () => {
                AlgoliaUtils$1.updateLocationParams('', []);
                AlgoliaRenderer$1.toggleSuggestions('initial');
            });

            // watch for user input in the search input field
            searchInput.addEventListener('input', async (Event) => {
                const searchString = Event.target.value.toLowerCase().trim();

                updateSubmitState();
                const searchCurrentPageOnly = searchForm.querySelector('.js-gs-searchform--filter-checkbox:checked');
                const searchCurrentPage = searchCurrentPageOnly ? searchCurrentPageOnly.value : null;

                const hasRealQuery = AlgoliaUtils$1.hasRealQuery(searchString);

                if (Event.target.value.length <= 2 || !hasRealQuery) {
                    AlgoliaRenderer$1.toggleSuggestions('initial');
                }

                if (Event.target.value.length > 2 && hasRealQuery) {
                    AlgoliaRenderer$1.toggleSuggestions('performed');
                    // avoid flashing a stale (e.g. no-results) message while the new request is in flight
                    AlgoliaRenderer$1.clearAutosuggestResults();

                    // example: call PHP AJAX endpoint instead of direct Algolia JS client
                    const quickResults = await AlgoliaAjaxActions$1.performAjaxQuickResults();

                    // superseded by a newer keystroke while this request was in flight/aborted
                    if (!quickResults) {
                        return;
                    }

                    const [suggestionsResult, ...topResults] = quickResults.results;

                    AlgoliaRenderer$1.renderAutosuggestResults(searchString, suggestionsResult.hits);
                    AlgoliaRenderer$1.renderTopResults(searchString, topResults);
                }
            });

            // handle overlay state
            // 'inert' keeps the (still off-screen) overlay content out of the tab order while closed
            const openOverlay = () => {
                overlay.setAttribute('open', 'open');
                overlay.removeAttribute('inert');
            };

            const closeOverlay = () => {
                overlay.setAttribute('inert', 'inert');
                overlay.removeAttribute('open');
            };

            // remembers which toggle button opened the overlay, so ESC can return focus to it
            let lastOverlayTrigger = null;

            btnOpenOverlay.addEventListener('click', () => {
                lastOverlayTrigger = btnOpenOverlay;
                openOverlay();
                AlgoliaUtils$1.checkForCurrentPageOnlyFilter();
                searchInput.focus();
            });

            btnOpenOverlayMobile.addEventListener('click', () => {
                lastOverlayTrigger = btnOpenOverlayMobile;
                openOverlay();
                searchInput.focus();
            });

            btnCloseOverlay.addEventListener('click', () => {
                closeOverlay();
            });

            // close overlay on ESC when no child element (e.g. input) holds the focus
            document.addEventListener('keydown', (event) => {
                if (event.key !== 'Escape') {
                    return;
                }

                if (!overlay.hasAttribute('open')) {
                    return;
                }

                if (overlay.contains(document.activeElement)) {
                    document.activeElement.blur();
                    return;
                }

                closeOverlay();

                if (lastOverlayTrigger) {
                    lastOverlayTrigger.focus();
                }
            });

            // close overlay once focus moves to an element outside of it (e.g. via Tab)
            document.addEventListener('focusin', (event) => {
                if (!overlay.hasAttribute('open')) {
                    return;
                }

                if (overlay.contains(event.target)) {
                    return;
                }

                closeOverlay();
            });

            searchForm.addEventListener('reset', async () => {
                AlgoliaRenderer$1.toggleSuggestions('initial');
                // the 'reset' event fires before the browser actually clears the field values
                setTimeout(updateSubmitState, 0);
            });

            searchForm.addEventListener('submit', async (Event) => {
                const searchCurrentPageOnly = searchForm.querySelector('.js-gs-searchform--filter-checkbox:checked');
                const searchCurrentPage = searchCurrentPageOnly ? searchCurrentPageOnly.value : null;

                // block an empty/invalid query so it never reaches Algolia with a "match everything" request
                if (!AlgoliaUtils$1.hasRealQuery(searchInput.value) && searchCurrentPage === null) {
                    Event.preventDefault();
                    return;
                }

                // already on the search results page: update it in place via AJAX instead of a full reload;
                // any other page must fall through to the native navigation to the search results page
                if (AlgoliaUtils$1.isOnSearchResultsPage()) {
                    Event.preventDefault();

                    const ajaxResults = await AlgoliaAjaxActions$1.performAjaxSearch();

                    btnCloseOverlay.click();

                    AlgoliaRenderer$1.renderSearchResultsFacets(ajaxResults);
                    AlgoliaRenderer$1.renderResultsCount(ajaxResults);
                    AlgoliaRenderer$1.renderSearchResults(ajaxResults);
                    AlgoliaRenderer$1.renderPagination(ajaxResults);
                    AlgoliaRenderer$1.renderPageCount(ajaxResults);
                }
            });
        }
    }

    new AlgoliaEventListener();

    class AlgoliaEventListener$1 {
        constructor() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
            } else {
                this.init();
            }
        }

        // reflects whether a submit would actually be allowed (see the 'submit' listener below)
        updateSubmitState() {
            const searchForm = document.querySelector('.js-gs-resultpage-searchform');
            const searchInput = document.querySelector('.js-gs-resultpage-searchinput');
            const btnSubmitSearch = document.querySelector('.js-gs-resultpage-submit');

            if (!searchForm || !searchInput || !btnSubmitSearch) {
                return;
            }

            const currentPageOnlyChecked = searchForm.querySelector('.js-gs-searchform--filter-checkbox:checked');

            btnSubmitSearch.disabled = !AlgoliaUtils$1.hasRealQuery(searchInput.value) && !currentPageOnlyChecked;
        }

        async init() {
            // attached regardless of location.search, otherwise a page load without a query
            // (e.g. after switching the language, which drops q/facetFilters) leaves the
            // facets/pagination controls rendered but without any event listeners forever
            this.listenForInteraction();

            // this script is loaded site-wide (the overlay can be opened from any page), so this
            // must not run outside the actual search results page just because the URL has a query string
            if (!AlgoliaUtils$1.isOnSearchResultsPage()) {
                return;
            }

            if (location.search) {
                const params = new URLSearchParams(location.search);
                const q = params.get('q') || '';
                let page = Number(params.get('page')) || 0;
                // const searchCurrentPage = params.get('current-page-only');
                // const searchFacets = params.get('facetFields');

                /*
                if (searchCurrentPage !== null) {
                    searchFacets.push(`'package:${searchCurrentPage}'`);
                }
                */

                // mirror the search input's guard: an empty/invalid "q" (e.g. a bookmarked/shared
                // "?q=" link) must not reach Algolia unless facets/page were deliberately requested too.
                // Just sync the checkbox state (not .click(), which would fire the change listener
                // and still trigger a "match everything" request) and leave the results area empty.
                if (!AlgoliaUtils$1.hasRealQuery(q) && !params.has('facetFilters') && !params.has('page')) {
                    const facetAllCheckbox = document.querySelector('#facetall');

                    if (facetAllCheckbox) {
                        facetAllCheckbox.checked = true;
                    }

                    return;
                }

                AlgoliaUtils$1.applyFacetsFromLocation();

                let ajaxResults = await AlgoliaAjaxActions$1.performAjaxSearch(page);

                // q/facetFilters and page come from the URL independently, so the requested page
                // can be out of range for the filtered result set
                const nbPages = Number(ajaxResults.results[0].nbPages) || 0;
                if (page > 0 && page >= nbPages) {
                    page = 0;
                    AlgoliaUtils$1.updatePageParam(page);
                    ajaxResults = await AlgoliaAjaxActions$1.performAjaxSearch(page);
                }

                // document.querySelector(this.class.searchInput).value = q;
                AlgoliaRenderer$1.renderSearchResultsFacets(ajaxResults);
                AlgoliaRenderer$1.renderResultsCount(ajaxResults);
                AlgoliaRenderer$1.renderPagination(ajaxResults);
                AlgoliaRenderer$1.renderPageCount(ajaxResults);
                AlgoliaRenderer$1.renderSearchResults(ajaxResults);

                // the input value above was just set programmatically (no 'input' event fired)
                this.updateSubmitState();
            } else {
                // no query yet (e.g. right after a language switch drops q/facetFilters) - sync the "all"
                // facet checkbox state only (not .click(), which would trigger an unwanted empty-query request)
                const facetAllCheckbox = document.querySelector('#facetall');

                if (facetAllCheckbox) {
                    facetAllCheckbox.checked = true;
                }
            }
        }

        listenForInteraction() {
            // basic elements
            // elements inside the overlay
            // const searchForm = document.querySelector(this.class.searchForm);
            // const searchInput = document.querySelector(this.class.searchInput);
            const filtersList = document.querySelector('.js-gs-filters-list');
            const pagination = document.querySelector('.js-gs-pagination');
            const searchForm = document.querySelector('.js-gs-resultpage-searchform');
            const searchInput = document.querySelector('.js-gs-resultpage-searchinput');

            // block the native GET submit for an empty/invalid query so it never
            // reaches Algolia with a "match everything" request (see algoliaQuickResultsAction)
            if (searchForm && searchInput) {
                this.updateSubmitState();
                searchInput.addEventListener('input', () => this.updateSubmitState());
                searchForm.addEventListener('change', () => this.updateSubmitState());
                // the 'reset' event fires before the browser actually clears the field values
                searchForm.addEventListener('reset', () => setTimeout(() => this.updateSubmitState(), 0));

                searchForm.addEventListener('submit', (Event) => {
                    const currentPageOnly = searchForm.querySelector('.js-gs-searchform--filter-checkbox:checked');

                    if (!AlgoliaUtils$1.hasRealQuery(searchInput.value) && !currentPageOnly) {
                        Event.preventDefault();
                    }
                });
            }

            if (pagination) {
                pagination.addEventListener('click', async (Event) => {
                    Event.preventDefault();
                    const params = new URLSearchParams(location.search);
                    const totalPagesEl = document.querySelector('.js-total-pages');
                    const nbPages = Number((totalPagesEl && totalPagesEl.textContent) || 0);

                    let page = Number(params.get('page') || 0);

                    if (Event.target.closest('.js-gs-paging-page')) {
                        page = Number(Event.target.closest('.js-gs-paging-page').dataset.page);
                    } else if (Event.target.closest('.js-gs-paging-previous')) {
                        page = Math.max(0, page - 1);
                    } else if (Event.target.closest('.js-gs-paging-next')) {
                        page = Math.min(nbPages - 1, page + 1);
                    } else if (Event.target.closest('.js-gs-paging-first')) {
                        page = 0;
                    } else if (Event.target.closest('.js-gs-paging-last')) {
                        page = nbPages - 1;
                    } else {
                        return;
                    }

                    AlgoliaUtils$1.updatePageParam(page);

                    const ajaxResults = await AlgoliaAjaxActions$1.performAjaxSearch(page);

                    AlgoliaRenderer$1.renderSearchResultsFacets(ajaxResults);
                    AlgoliaRenderer$1.renderResultsCount(ajaxResults);
                    AlgoliaRenderer$1.renderPagination(ajaxResults);
                    AlgoliaRenderer$1.renderPageCount(ajaxResults);
                    AlgoliaRenderer$1.renderSearchResults(ajaxResults);
                    window.scrollTo(0, 0);
                });
            }

            if (filtersList) {
                // labels are focusable via tabindex but, unlike native form controls, don't
                // react to Space/Enter on their own
                filtersList.addEventListener('keydown', (event) => {
                    if (event.key !== ' ' && event.key !== 'Enter') {
                        return;
                    }

                    const label = event.target.closest('label');

                    if (!label) {
                        return;
                    }

                    event.preventDefault();
                    label.click();
                });

                filtersList.addEventListener('change', async (Event) => {
                    const changedCheckbox = Event.target;

                    if (!(changedCheckbox instanceof HTMLInputElement)) {
                        return;
                    }

                    if (changedCheckbox.type !== 'checkbox' || !changedCheckbox.checked) {
                        filtersList.querySelector('#facetall').click(); // select the "all" checkbox
                        filtersList.querySelector('label[for="facetall"]').focus();
                        return;
                    }

                    // uncheck all other checkboxes except the one that was just checked
                    const otherCheckboxes = Array.from(filtersList.querySelectorAll('input[type="checkbox"]')).filter((checkbox) => checkbox !== changedCheckbox);
                    otherCheckboxes.forEach((_, index) => {
                        otherCheckboxes[index].checked = false;
                    });

                    // changing a facet invalidates the current result set, so pagination must restart at page 0
                    const page = 0;
                    AlgoliaUtils$1.updatePageParam(page);

                    const ajaxResults = await AlgoliaAjaxActions$1.performAjaxSearch(page);

                    AlgoliaRenderer$1.renderSearchResultsFacets(ajaxResults);
                    AlgoliaRenderer$1.renderResultsCount(ajaxResults);
                    AlgoliaRenderer$1.renderPagination(ajaxResults);
                    AlgoliaRenderer$1.renderPageCount(ajaxResults);
                    AlgoliaRenderer$1.renderSearchResults(ajaxResults);
                });
            }
        }
    }

    new AlgoliaEventListener$1();

}));
